var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home data-panel-home"},[_c('PCHeader'),_c('PcLogin'),_c('div',{staticClass:"main-container"},[_c('PageHeader'),_c('BannerContainer'),_c('Highlight'),_c('Advantage'),_c('Community')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }